import React, { useReducer } from 'react';
import SubGrupoContext from './subgrupoContext';
import SubGrupoReducer from './subgrupoReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_SUBGRUPOS,
    AGREGAR_SUBGRUPO,
    ELIMINAR_SUBGRUPO,
    ACTUALIZAR_SUBGRUPO,
    SUBGRUPO_ERROR,
    SUBGRUPO_OK,
    SUBGRUPO_ACTUAL,
    OBTENER_SUBGRUPO,
} from 'types/context';

const SubGrupoState = props => {
    const initialState = {
        subGrupos : [], // subGrupos del cliente
        subGrupo: null,
        nuevoSubgrupo:null,
        cliente: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(SubGrupoReducer, initialState);

    // Obtener los SubGrupos
    const obtenerSubGrupos = async (grupoId) => {
        try {
            // siempre deberia venir un grupo

            let resultado;
            if(grupoId){
                resultado = await clienteAxios.get(`/subgrupos?grupoId=${grupoId}`);
            }else{
                resultado = await clienteAxios.get('/subgrupos');
            }
            
            //console.log(resultado);
            dispatch({
                type: OBTENER_SUBGRUPOS,
                payload: resultado.data.subgrupos.rows
            });
            //console.log("Obtener SubGrupos")
            return {
                data: resultado.data.subgrupos.rows,
                page: resultado.data.pagina - 1,
                totalCount: resultado.data.count
            }             
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: SUBGRUPO_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo subGrupo
    const agregarSubGrupo = async subGrupo => {
        try {
            const resultado = await clienteAxios.post('/subgrupos', subGrupo);
            //console.log(resultado);
            // Insertar el subGrupo en el estado
            dispatch({
                type: AGREGAR_SUBGRUPO,
                payload: resultado.data.subgrupo
            })
            const alerta = {
                msg: "Subgrupo creado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: SUBGRUPO_OK,
                payload: alerta
            })
            return resultado.data.subgrupo
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: SUBGRUPO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Selecciona el subGrupo que el usuario dio click
    const subGrupoActual = subGrupoId => {
        dispatch({
            type: SUBGRUPO_ACTUAL,
            payload: subGrupoId
        })
    }

    // Elimina un subGrupo
    const eliminarSubGrupo = async subGrupoId => {
        try {
            await clienteAxios.delete(`/subgrupos/${subGrupoId}`);
            dispatch({
                type: ELIMINAR_SUBGRUPO,
                payload: subGrupoId
            })
            const alerta = {
                msg: "Subgrupo eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: SUBGRUPO_OK,
                payload: alerta
            })
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: SUBGRUPO_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar subGrupo
    const actualizarSubGrupo = async subGrupo => {

        try {
            const resultado = await  clienteAxios.put(`/subgrupos/${subGrupo.id}`, subGrupo);
            //console.log(resultado);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_SUBGRUPO,
                payload: resultado.data.subgrupo
            })
            const alerta = {
                msg: "Subgrupo editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: SUBGRUPO_OK,
                payload: alerta
            })
            return resultado.status
            } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: SUBGRUPO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorSubGrupo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: SUBGRUPO_ERROR,
            payload: alerta
        })
    }
    // muestra un error de validacion
    const OkSubGrupo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: SUBGRUPO_OK,
            payload: alerta
        })
    }

    const clearErrorSubGrupo = () => {
        dispatch({
            type: SUBGRUPO_ERROR,
            payload: null,
        });
        };

        const clearOkSubGrupo = () => {
            dispatch({
                type: SUBGRUPO_OK,
                payload: null,
            });
            };

    // Obtengo un subGrupo por id
    const obtenerSubGrupo = async (subGrupoId) => {
        try {
            const resultado = await clienteAxios.get(`/subgrupos?id=${subGrupoId}`);                   
           
            dispatch({
                type: OBTENER_SUBGRUPO,
                payload: resultado.data.subgrupo
            })
            return resultado.data.subgrupo;            
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: SUBGRUPO_ERROR,
                payload: alerta
            })
        }
    }

    return(
        <SubGrupoContext.Provider
            value={{
                subGrupos: state.subGrupos,
                subGrupo: state.subGrupo,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerSubGrupos,
                agregarSubGrupo,
                subGrupoActual,
                clearErrorSubGrupo,
                clearOkSubGrupo,
                eliminarSubGrupo,
                actualizarSubGrupo,
                errorSubGrupo,
                OkSubGrupo,
                obtenerSubGrupo,
            }}
        >{props.children}

        </SubGrupoContext.Provider>
    )
}
export default SubGrupoState;
